export const INVOICE_ORGANIZATION_NAME = "Latino Business Support";

const PRODUCT_APP_TITLES = new Set([
  "SIGMA",
  "Sigma by Latino Business Support",
  "Nomi CRM",
  "LBS CRM",
  "Atomic CRM",
  "LBS",
  "Nomi",
  "NOMI",
  "NOMI CRM",
]);

/** Public-facing org name for client emails/SMS — not the CRM product title. */
export const resolveInvoiceOrganizationName = (config?: {
  title?: string | null;
}) => {
  const title = config?.title?.trim();
  if (title && !PRODUCT_APP_TITLES.has(title)) return title;
  return INVOICE_ORGANIZATION_NAME;
};

export const INVOICE_ORGANIZATION_ADDRESS_LINE =
  "1200 Summer St, Stamford CT, 06902";

export const INVOICE_ORGANIZATION_PHONE = "(203) 303-9148";

export const INVOICE_ORGANIZATION_EMAIL = "info@lbs.bz";

export const INVOICE_ORGANIZATION_WEBSITE = "www.lbs.bz";

export const INVOICE_ORGANIZATION_CONTACT_LINE = `${INVOICE_ORGANIZATION_PHONE} | ${INVOICE_ORGANIZATION_EMAIL}`;

export const INVOICE_ORGANIZATION_ADDRESS_BLOCK = `${INVOICE_ORGANIZATION_ADDRESS_LINE}\n${INVOICE_ORGANIZATION_CONTACT_LINE}`;

export const getPublicInvoiceOrganization = () => ({
  name: INVOICE_ORGANIZATION_NAME,
  website: INVOICE_ORGANIZATION_WEBSITE,
  address: INVOICE_ORGANIZATION_ADDRESS_BLOCK,
});

/** Compact LBS wordmark when no banner is used (150px header). */
export const INVOICE_ORGANIZATION_EMAIL_LOGO_URL =
  "https://www.nomicrm.com/logos/latino-business-support-email@2x.jpg";

/** Blue wordmark on the file-delivery card. PNG: Outlook does not show WebP. */
export const INVOICE_ORGANIZATION_EMAIL_MARK_URL =
  "https://www.nomicrm.com/logos/lbs-logo-blue.png";

/** Full-width LBS header on client billing and ticket emails (560px column). */
export const INVOICE_ORGANIZATION_EMAIL_BANNER_URL =
  "https://www.nomicrm.com/logos/latino-business-support-email-banner.png";

/**
 * Brand block for client billing emails. LBS contact details only apply to
 * the home org; logo comes from Settings → Branding (see loadOrgEmailBrand).
 */
export const getBillingEmailBrand = (orgName?: string | null) => {
  const name = orgName?.trim() || INVOICE_ORGANIZATION_NAME;
  // Org name, or an LBS inbox sender name such as "LBS Supplements".
  const isLbs =
    name === INVOICE_ORGANIZATION_NAME ||
    /\b(lbs|latino business support)\b/i.test(name);
  return {
    name,
    logoUrl: isLbs ? INVOICE_ORGANIZATION_EMAIL_MARK_URL : null,
    bannerUrl: isLbs ? INVOICE_ORGANIZATION_EMAIL_BANNER_URL : null,
    phone: isLbs ? INVOICE_ORGANIZATION_PHONE : null,
    email: isLbs ? INVOICE_ORGANIZATION_EMAIL : null,
    website: isLbs ? INVOICE_ORGANIZATION_WEBSITE : null,
  };
};
